"use strict";

angular.module('PatientApp').factory('EstimatesService', function ($log, $resource, $q, _, $filter, endpoints, LinkedAccountsService, MoneyUtilsService, VuexStore, Models) {
  var EstimatesService = {
    createEstimate: function createEstimate(estimate) {
      if (estimate instanceof Models.Estimate) {
        return estimate;
      }

      return new Models.Estimate(estimate);
    },
    isEstimate: function isEstimate(estimate) {
      return estimate instanceof Models.Estimate;
    },
    getAccountEstimate: function getAccountEstimate(id) {
      return VuexStore.dispatch('fetchEstimate', id);
    },
    getCurrentEstimate: function getCurrentEstimate() {
      return VuexStore.state.EstimatesStore.currentEstimate;
    },
    flushCurrentEstimate: function flushCurrentEstimate() {
      VuexStore.commit('setCurrentEstimate', null);
    },
    markOpened: function markOpened(token) {
      return VuexStore.dispatch('markOpenedEstimate', token);
    },
    link: function link(estimate) {
      return VuexStore.dispatch('linkEstimate', estimate);
    },

    /**
        Get verification options from DFE token
    */
    findAuthOptions: function findAuthOptions(token) {
      return VuexStore.dispatch('findAuthOptionsEstimate', token);
    },

    /**
        Look up estimate from DFE verification step and 
        links estimate to wallet if already logged in
    */
    findNew: function findNew(token, verificationCode, guarantorLast4SSN, guarantorDOB, zip) {
      return VuexStore.dispatch('findNewEstimate', {
        token: token,
        verificationCode: verificationCode,
        guarantorLast4SSN: guarantorLast4SSN,
        guarantorDOB: guarantorDOB,
        zip: zip
      });
    },

    /**
        Kicks off sending email/sms verification code
    */
    firstEstimateGetCode: function firstEstimateGetCode(token) {
      return VuexStore.dispatch('firstEstimateGetCode', token);
    }
  };
  return EstimatesService;
});